module.exports = __webpack_public_path__ + "img/dialog_bg.70a004f7.png";